import { Component, OnInit } from '@angular/core';
import { GestionSACService } from '../../service/gestionSAC/gestionSAC.service';
import { GestionSAC } from '../../class/gestionSAC';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { config } from '../../../../../environments/config';
import { CompanyService } from '../../service/company/company.service';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';
import { formControlBinding } from '@angular/forms/src/directives/reactive_directives/form_control_directive';


@Component({
  selector: 'app-gestionSACs',
  templateUrl: './gestionSACs.component.html',
  styleUrls: ['./gestionSACs.component.scss']
})
export class GestionSACsComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public gestionSACs: GestionSAC[];
    public selectGestionSAC: GestionSAC;
    public gestionSACID: Number = 0;
    public modNew = false;
    public modView = false;
    public openGestionSAC = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;

    public form3: FormGroup;
    public params_id_company: number;

    public params_id_gestionSAC: number;

    public modExportDialog: boolean;
    public form4: FormGroup;
    public apiUrl = config.API_ROOT;


    public filters: any[];

    public es: any;

    public first = 0;

    constructor(
        public gestionSACService: GestionSACService,
        public confirmationService: ConfirmationService,
        public hasPermissionService: HasPermissionService,
        public translate: TranslateService,
        public activatedRoute: ActivatedRoute,
        public companyService: CompanyService,
        public fb: FormBuilder
        ) {
            this.es = calendarES();

            this.modExportDialog = false;
        }

    ngOnInit() {
        this.page = 1;
        this.per_page = 10;
        this.sort = '-id';

        this.activatedRoute.queryParams.subscribe(params => {
            if (params['id_company']) {
                this.params_id_company = Number(params['id_company']);
                const filters = [];
                if (this.params_id_company) {
                    filters.push({key: 'id-lk', value: String(this.params_id_company)});
                }
                this.getCompanies(undefined, filters);
            }
            if (params['id_gestionSAC']){
                this.params_id_gestionSAC = Number(params['id_gestionSAC']);
                const filters = [];
                if (this.params_id_gestionSAC) {
                    filters.push({key: 'id-lk', value: String(this.params_id_gestionSAC)});
                    this.getGestionSacById(this.query, filters);
                }
            }
            //this.filter();
        });
        this.createForm3(null);

        this.createForm4(null);
    }

    public createForm3(data:any = null){
      data = data || {
        company_id_filter: '',
        employee_id_filter: ''
      };
      this.form3 = this.fb.group({
        company_id_filter: new FormControl(data.company_id_filter),
        employee_id_filter: new FormControl(data.employee_id_filter)
      })
    }

    public createForm4(data:any = null){
      data = data || {
        f4_date_start: '',
        f4_date_end: '',
        f4_company_id: '',
        f4_employee_id: ''
      };
      this.form4 = this.fb.group({
        f4_date_start: new FormControl(data.f4_date_start, Validators.compose([Validators.required])),
        f4_date_end: new FormControl(data.f4_date_end, Validators.compose([Validators.required])),
        f4_company_id: new FormControl(data.f4_company_id),
        f4_employee_id: new FormControl(data.f4_employee_id)
      });
    }

    public loadGestionSACsLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }

        this.sort = '-id';
        var values = this.form3.value;
        this.filter(null,values);
    }

    public getGestionSACs() {
        this.gestionSACService.getGestionSAC(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                this.gestionSACs = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public getGestionSacById(query?: string, filters?: any[]){
        // this.loading = true;
        this.gestionSACService.getGestionSAC(this.page, this.per_page, this.sort, this.query, filters).toPromise().then(
            response => {
                // this.loading = false;
                this.edit(response.json().data[0]);
            },
            error => {
                // this.loading = false;
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );

    }

    printGestionSac(GestionSAC) {
        window.open(this.apiUrl + '/gestionSACs/' + GestionSAC.id + '/pdf?token=' + localStorage.getItem('token'), '_blank');
    }


    public newGestionSAC() {
        this.modNew = !this.modNew;
        this.selectGestionSAC = null;
    }

    public savedGestionSAC(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectGestionSAC = null;
        this.modNew = false;
        // this.getGestionSACs();//Comentado porque existe componente y se quita y detecta load_lazy
    }

    public cancelGestionSAC (res) {
        this.selectGestionSAC = null;
        this.modNew = false;
        this.modView = false;
        // this.getGestionSACs();//Comentado porque existe componente y se quita y detecta load_lazy
    }

    public edit(gestionSAC: GestionSAC) {
        this.modNew = true;
        this.selectGestionSAC = gestionSAC;
        // this.getGestionSACs();
    }

    public view(gestionSAC: GestionSAC) {
        this.openGestionSAC = true;
        this.selectGestionSAC = gestionSAC;
        this.gestionSACID = gestionSAC.id;
        this.modView = true;
    }

    public deleteDialog(gestionSAC: GestionSAC) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(gestionSAC);
            }
        });
    }

    public delete(gestionSAC: GestionSAC) {
        this.gestionSACService.deleteGestionSAC(gestionSAC.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getGestionSACs();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeGestionSAC(gestionSAC: GestionSAC) {
        this.putGestionSAC(gestionSAC);
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public hasRole(rol){
        var r: boolean=false;
        var role = JSON.parse(localStorage.getItem('profile')).roles[0].id;
        if(role == rol){
            r = true;
        }
        return (r);
    }

    public putGestionSAC(values: GestionSAC) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.gestionSACService.updateGestionSAC(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    public filterRefresh (values) {
        this.params_id_company = undefined;
        this.filter(true, values);
    }

    public filter (pageRefresh?, values?) {

        console.log(values);
        var myRoleId = JSON.parse(localStorage.getItem('profile')).roles[0].id;

        if (pageRefresh) {
            this.page = 1;
            this.first = 0;
        }

        this.filters = [];

        if(values){
          if (values.company_id_filter.id) {
            if (values.company_id_filter.id) {
                this.filters.push({'key': 'company_id-lk', 'value': values.company_id_filter.id});
            }
          } else if (this.params_id_company) {
              this.filters.push({'key': 'company_id-lk', 'value': this.params_id_company});
          }


          if (values.employee_id_filter) {
              if (values.employee_id_filter.id) {
                  this.filters.push({'key': 'employee_id-lk', 'value': values.employee_id_filter.id});
              }
        }
        }
        this.getGestionSACs();
    }

    public showExportDialog() {
        this.modExportDialog = true;
    }

    public cancelExport() {
        this.modExportDialog = false;
    }

    public exportReportExcel(values) {
        let d = new Date(values.f4_date_start);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);

        const f4_date_start = formatDate(d);

        d = new Date(values.f4_date_end);
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(59);
        const f4_date_end = formatDate(d);

        let url = this.apiUrl + '/gestionSACs/excel?' +
        'token=' + localStorage.getItem('token') +
        '&_page=1&_limit=100000&_sort=id&';

        if (f4_date_start) {
            url = url + 'created_at-min=' + f4_date_start + '&';
        }

        if (f4_date_end) {
            url = url + 'created_at-max=' + f4_date_end + '&';
        }

        if (values.f4_company_id) {
            url = url + 'company_id-in=' + values.f4_company_id.id + '&';
        }

        if (values.f4_employee_id) {
            url = url + 'employee_id-in=' + values.f4_employee_id.id + '&';
        }

        window.open(url, '_blank');
    }

    getCompanies(query?: string, filters?: any[]) {
        this.companyService.getCompany(this.page, this.per_page, this.sort, query, filters).toPromise().then(
            response => {
                const companiesOptions = response.json().data;
                this.form4.controls.company_id_filter.setValue(companiesOptions[0]);
            },
            error => {
                this.form4.controls.company_id_filter.setValue(undefined);
            }
        );
    }



}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/gestionSACs/gestionSACs.component.ts